import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../Provider/Alert/AlertContext";
import { getData } from "../../Services/apiService";

export function useContract({ idClient, listContracts = () => {} }) {
    const { t } = useTranslation(); // Translation hook
    const { addAlert } = useAlert(); // Alert hook
    const [loading, setLoading] = useState(true); // Loading hook
    const [contracts, setContracts] = useState([]); // Contracts hook
    const [search, setSearch] = useState(""); // Search hook
    const [reload, setReload] = useState(0); // Reload hook

    // Fetch contracts when idClient or reload changes
    useEffect(() => {
        if (idClient) {
            getListContracts();
        }
        // eslint-disable-next-line
    }, [idClient, reload, search]);

    /**
     * Fetches contracts for a specific client from the API and updates the state.
     * Handles both successful and error responses.
     *
     * @async
     * @function fetchContracts
     * @returns {Promise<void>} Resolves when contracts are fetched and state is updated.
     */
    const getListContracts = async () => {
        // Get the query string from the local storage
        let queryString = JSON.parse(localStorage.getItem("contracts"));
        if (!queryString) {
            queryString = {
                page: 1,
                limit: 10,
                totalItems: 0,
                order: [{ field: "id", direction: "asc" }],
            };
            localStorage.setItem("contracts", JSON.stringify(queryString));
        }

        // Get the licenses for the client
        let uri = `/client/${idClient}/contract?page=${queryString.page}&limit=${queryString.limit}`;

        // Adicionar ordenações à URI
        const orderString = encodeURIComponent(
            JSON.stringify(queryString.order)
        );
        uri += `&order=${orderString}`;

        // Adicionar filtros à URI
        if (search !== "") {
            const searchString = encodeURIComponent(
                JSON.stringify([
                    {
                        field: "description",
                        operator: "like",
                        value: `%${search}%`,
                    },
                ])
            );
            uri += `&where=${searchString}`;
        }

        console.log("Fetching contracts with URI:", uri);

        // Await the response
        const getLicenses = getData(uri);
        getLicenses.then((response) => {
            console.log("Response received:", response);
            if (response.status === 200) {
                setContracts(response.body.data);
                listContracts(response.body.data); // Retorna a lista de contratos para o componente pai
                queryString.lastPage = response.body.total_pages;
                queryString.totalItems = response.body.total_items;
                localStorage.setItem("contracts", JSON.stringify(queryString));
                setLoading(false);
                return;
            }
            addAlert("danger", t("license.alert.error"), response.body);
        });
    };

    return {
        contracts,
        loading,
        setSearch,
        setReload: () => setReload(reload + 1),
    };
}
